import PerformanceManagement from "@/modules/performance/pages/PerformanceManagement";

export default function PerformancePage() {
  return <PerformanceManagement />;
}
